import React from 'react';
import { Props } from '../../types';
import { Container } from '../../styles';
import { orange, blue, green } from '../../index';

const Status: React.FC<Props> = ({ acronym }) => {
  let text = React.useRef('');
  let color = React.useRef('');

  switch (acronym) {
    case 'ANFC':
      color.current = orange;
      text.current = 'Aguardando nota de cobertura';
      break;
    case 'CR':
      color.current = green;
      text.current = 'Cobertura Realizada';
      break;
    case 'NC':
      color.current = blue;
      text.current = 'Não necessita cobertura';
      break;
    default:
      color.current = '#777';
      text.current = 'Sem informações de status';
      break;
  }

  return (
    <Container data-cy="statusAtendimento" color={color.current}>
      {text.current}
    </Container>
  );
};

export default Status;
